import React, { Component } from "react";

import { parse } from "query-string";

import {
  Button,
  CardActions,
  Show,
  TabbedShowLayout,
  NumberField,
  Datagrid,
  TextField,
  Link,
  ReferenceManyField,
  DateField,
  Tab,
  FunctionField,
  Pagination,
  Filter,
  DateInput,
  List,
  ShowController,
  SelectInput,
  ShowButton,
  TextInput,
} from "react-admin";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { prop, head, isNil } from "ramda";
import dataProviderFactory from "../dataProvider";
import { UPDATE } from "react-admin";
import ForwardIcon from "@material-ui/icons/Forward";
import RefundChargeButton from "../components/refundCharge";
import moment_tz from 'moment-timezone';
import { getPermissionRole } from "../util";

import moment from "moment";
const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};
moment_tz.tz.setDefault("Europe/Madrid");
const ListPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const rentalTypes = [
  { _id: 1, description: "Tours" },
  { _id: 2, description: "Rentals" },
];

const paymentTypes = [
  { _id: "rental", description: "Rental" },
  { _id: "extra_charge", description: "Extra Charge" },
  { _id: "damage", description: "Damage" },
  { _id: "storage", description: "Storage" },
];

const PaymentsFilter = (props) => (
  <Filter {...props}>
    <DateInput label="Date From" source="from" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <SelectInput
      label="Rental Type"
      source="rental_type"
      choices={rentalTypes}
      optionText="description"
      optionValue="_id"
      alwaysOn
    />
    <SelectInput
      label="Payment Type"
      source="payment_type"
      choices={paymentTypes}
      optionText="description"
      optionValue="_id"
      alwaysOn
      allowEmpty={false}
    />
    <TextInput label="First or Last Name" source="client_name" alwaysOn />
  </Filter>
);

const SpecialBackButton = (object) => {
  let redirectTo = `/${object.record.rentals[0].type === 1 ? "tour_clients" : "rental_clients"
    }/${object.record.type_id}/show`;

  if (!isNil(object.redirect)) {
    redirectTo = `/clients/${object.redirect}/4`;
  }

  return (
    <Button
      component={Link}
      to={{
        pathname: redirectTo,
      }}
      label="Back"
    />
  );
};

const PaymentShowTitle = (object) => {
  return (
    <span>
      {" Payments for"} &quot;
      {`${object.record.rentals[0].type === 1 ? "Tour" : "Rental"} ${object.record.type_id
        }`}
      &quot;
    </span>
  );
};

const PaymentShowActions = ({ basePath, data, resource }) => (
  <CardActions style={cardActionStyle} />
);

class RefundButton extends Component {
  state = {
    refunded: false,
  };

  handleClick = async () => {
    // const { push, record, showNotification } = this.props;
    const { record } = this.props;
    const dataProvider = await dataProviderFactory("rest");
    const bodyRequest = { id: record.id, data: { status: 2 } };

    this.setState({ refunded: true });

    dataProvider(UPDATE, "charges", bodyRequest)
      .then((response) => {
        console.log(response);
        //push(`/payments/${record.payment_id}/show`);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  render() {
    const { refunded } = this.state;
    if (!refunded) {
      return (
        <Button label="Refund" onClick={this.handleClick}>
          <ForwardIcon />
        </Button>
      );
    }

    return "";
  }
}

const InfoShow = (props) => (
  <ShowController {...props} title=" ">
    {({ record }) =>
      record && (
        <Card style={{ width: "100%", margin: "auto" }}>
          <CardContent>
            <Grid container spacing={16}>
              <Grid item xs={6}>
                <Typography variant="subheading" gutterBottom>
                  Charges List
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subheading" gutterBottom align="right">
                  Payment {record.id} (<b>{record.value.toFixed(2)}€</b>)
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={16}>
              <Grid item xs={12} align="right" />
            </Grid>
            <Grid container spacing={16}>
              <Grid item xs={3}>
                <Typography variant="subheading" gutterBottom align="center">
                  Date
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subheading" gutterBottom align="center">
                  Value
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subheading" gutterBottom align="center">
                  Status
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subheading" gutterBottom align="center">
                  Charge Type
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={16}>
              {record.charges &&
                record.charges.map((charge) => (
                  <React.Fragment key={charge.id}>
                    <Grid item xs={3}>
                      <Typography gutterBottom align="center">
                        {moment(charge.date).format("DD-MM-YYYY")}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography gutterBottom align="center">
                        {charge.value} €
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        gutterBottom
                        align="center"
                        style={{ color: charge.status ? "black" : "red" }}
                      >
                        {charge.status ? "Paid" : "Not Paid"}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography gutterBottom align="center">
                        {charge.charge_type === 1
                          ? "Stripe"
                          : "Money, Bank, Other"}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                ))}
            </Grid>
          </CardContent>
        </Card>
      )
    }
  </ShowController>
);

const ViewDetailsButton = (props) => {
  let rental = null;
  if (props.record.type === "damage") {
    rental = prop("rental", head(props.record.damages));
  } else {
    rental = head(props.record.rentals);
  }

  const title =
    props.record.type === "damage"
      ? "Damage"
      : rental.type === 1
        ? "Tour"
        : "Rental";
  const action = props.record.type === "damage" ? "" : "/show";
  const reditectTo =
    props.record.type === "damage"
      ? "vehicle_damages"
      : rental.type === 1
        ? "tour_clients"
        : "rental_clients";
  const id =
    props.record.type !== "damage"
      ? prop("id", head(prop("rentals", props.record)))
      : prop("id", head(prop("damages", props.record)));
  return (
    <ShowButton
      target="_blank"
      component={Link}
      to={{
        pathname: `/${reditectTo}/${id}${action}`,
      }}
      label={`${title} Details`}
    />
  );
};

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const PaymentList = (props) => (
  <List
    {...props}
    title="All Payments"
    resource="payments"
    pagination={<ListPagination />}
    filters={<PaymentsFilter />}
    filterDefaultValues={{ payment_type: "rental" }}
    bulkActionButtons={false}
  >
    <Datagrid rowClick="expand" expand={<InfoShow />}>
      <TextField label="Payment ID" source="id" />
      <DateField label="Date" locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="date" />
      <NumberField
        source="value"
        options={{ style: "currency", currency: "EUR" }}
      />
      <FunctionField
        label="Client"
        render={(item) => {
          if (item.type === "damage") {
            const client = prop("Client", head(item.damages));
            return `${client.client_first_name} ${client.client_last_name}`;
          } else {
            const booking = prop("booking", head(item.rentals));
            return `${booking.r_first_name} ${booking.r_last_name}`
          }
        }}
      />
      <FunctionField
        label="Payment Type"
        render={(item) => {
          return capitalize(item.type);
        }}
      />
      <FunctionField
        label="Rental Type"
        render={(item) => {
          let rental = {};
          if (item.type === "damage") {
            rental = prop("rental", head(item.damages));
          } else {
            rental = head(item.rentals);
          }

          return rental.type === 1 ? "Tour" : "Rental";
        }}
      />
      <ViewDetailsButton />
    </Datagrid>
  </List>
);

export const PaymentShow = ({ permissions, ...props }) => {
  const from = parse(props.location.search).client_id || null;

  return (
    <Show
      {...props}
      actions={<PaymentShowActions />}
      title={<PaymentShowTitle />}
    >
      <TabbedShowLayout>
        <Tab label="Charges">
          <ReferenceManyField
            label="Charges"
            reference="charges"
            target="payment_id"
          // filter={{ status: 1 }}
          >
            <Datagrid>
              <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <NumberField
                source="refunded_value"
                label="Refunded"
                options={{ style: "currency", currency: "EUR" }}
              />
              {/* <TextField source="token" /> */}
              <TextField source="stripe_status" />
              <TextField source="stripe_error" label="Stripe last error" />
              <TextField source="comments" />
              <TextField source="internal_comments" />
              <TextField source="old_invoice" />
              <FunctionField
                label="Status"
                render={(charge) => {
                  return ` ${charge.status
                    ? "Paid"
                    : charge.to_refund
                      ? "Refunded"
                      : "Not Paid"
                    }`;
                }}
              />
              <FunctionField
                label="Type"
                render={(charge) => {
                  return ` ${charge.charge_type === 1 ? "Stripe" : "Money / Bank / Other"
                    }`;
                }}
              />
              <TextField source="express_invoice_status" label="IE Status" />
              {/* <TextField source="invoice_express_error" label="IE Last Error" /> */}
              <FunctionField
                label="Invoice Url"
                render={(charge) => {
                  if (charge.express_invoice_url) {
                    return (
                      <a target="_blank" href={charge.express_invoice_url}>
                        Invoice ({charge.stripe_account_origin}) -{" "}
                        {charge.express_invoice_id}{" "}
                      </a>
                    );
                  } else {
                    return <p />;
                  }
                }}
              />
              {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && (
                  <FunctionField
                    render={(charge) => {
                      // if (charge.charge_type === 1 && charge.status) {
                      if (charge.refunded_value < charge.value) {
                        return (
                          <RefundChargeButton record={charge} history={props} />
                        );
                      }
                      return "";
                    }}
                  />
                )}
            </Datagrid>
          </ReferenceManyField>
          <SpecialBackButton redirect={from} />
        </Tab>

        {/* <Tab label="Refunds">
        <ReferenceManyField
          label="Refunds"
          reference="charges"
          target="payment_id"
          filter={{ status: 2 }}
        >
          <Datagrid>
            <DateField source="date" />
            <NumberField
              source="value"
              options={{ style: "currency", currency: "EUR" }}
            />
            <TextField source="token" />
            <TextField source="stripe_status" />
            <TextField source="stripe_error" />
            <TextField source="express_invoice_status" />
            <TextField source="invoice_express_error" />
            <FunctionField
              label="Invoice  Url"
              render={charge => {
                if (charge.express_invoice_url) {
                  return (
                    <a target="_blank" href={charge.express_invoice_url}>
                      Invoice - {charge.express_invoice_id}{" "}
                    </a>
                  );
                } else {
                  return <p />;
                }
              }}
            />
          </Datagrid>
        </ReferenceManyField>
        <SpecialBackButton />
      </Tab> */}
      </TabbedShowLayout>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/resources/payments.js